import { CampoRelatorioPreenchimento } from './campo-relatorio-preenchimento';
import { ComodoVistoriaPreenchimento } from './comodo-vistoria-preenchimento';

export enum SituacaoVistoria {
  EmAndamento = 1,
  Concluida = 2,
}

export const SituacaoVistoriaNomeMap = new Map<SituacaoVistoria, string>([
  [SituacaoVistoria.EmAndamento, 'Em andamento'],
  [SituacaoVistoria.Concluida, 'Concluída'],
]);

export interface Vistoria {
  id: number;
  modeloVistoriaId: number | null;
  modeloVistoriaNome: string | null;
  endereco: string;
  vistoriador: string;
  data: Date | null;
  situacao: SituacaoVistoria;
  /** Como veio da API (texto, sem converter): o rascunho local compara por igualdade. */
  dataModificacao: string | null;
  templateHtml: string;
  campos: CampoRelatorioPreenchimento[];
  comodos: ComodoVistoriaPreenchimento[];
}
